import { apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_DiseaseValue, DBDef_DiseaseValue } from '@app/dp-shared';
import { ModuleFE_Expression, ModuleFE_Value } from '@app/hcs-frontend';
import { arrayIncludesAny, dbObjectToId, Filter } from '@nu-art/ts-common';
export const dispatch_onDiseaseValueChanged = new ThunderDispatcherV3('__onDiseaseValueUpdated');
export class ModuleFE_DiseaseValue_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_DiseaseValue, dispatch_onDiseaseValueChanged);
        this._v1 = {
            convertToExpression: apiWithQuery(ApiDef_DiseaseValue._v1.convertToExpression, this.onConvertToExpression),
        };
    }
    __getSearchResults = (searchTerm) => {
        const filter = new Filter(ModuleFE_Value.__searchFilterMapper);
        filter.setRegexp(false);
        filter.prepareFilter(searchTerm);
        const passingValueIds = ModuleFE_Value.cache.filter(filter.filterImpl).map(dbObjectToId);
        return this.cache.filter(dv => !!dv._values.length && arrayIncludesAny(passingValueIds, dv._values));
    };
    onConvertToExpression = async (response) => {
        await ModuleFE_Expression.onEntriesUpdated([response.expression]);
        await this.onEntriesUpdated([response.diseaseValue]);
    };
}
export const ModuleFE_DiseaseValue = new ModuleFE_DiseaseValue_Class();
//# sourceMappingURL=ModuleFE_DiseaseValue.js.map